import Image from 'next/image';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
`;

export const ItemImage = styled(Image)`
  position: relative !important;
  width: 100%;
  max-height: 180px;
  object-fit: cover;
  z-index: 5;
  border-radius: 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 180px;
  }
`;

export const ContentWrapper = styled.div`
  width: calc(100% - 30px);
  margin: -25px auto 0 auto;
  box-shadow: 0 0 9px 0 rgba(222, 218, 218, 0.5);
  border-radius: 8px;
  z-index: 10;
  padding: 16px 30px 13px 30px;
  position: relative;
  background-color: ${({ theme }) => theme.palette.white};
  height: 250px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 18px 17px 10px 17px;
  }
`;

export const Label = styled.span<{ clickable?: boolean }>`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 18px;
  }
`;

export const List = styled.div`
  margin-top: 6px;
`;
export const ListItem = styled.div`
  display: flex;
  align-items: center;
  padding-right: 5px;
`;

export const Circle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.darkGrey};
`;

export const ItemContainer = styled.div`
  line-height: 2.11;
  color: ${({ theme }) => theme.palette.brownishGrey};
  margin-left: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px;
  }
`;

export const ItemArrow = styled.div`
  margin-left: auto;
  cursor: pointer;
`;
